/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationsBatchResponse {
    getFixupPrototypeFunction() { return ResourceRecommendationsBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationsBatchResponse>): ResourceRecommendationsBatchResponse {
        let obj = Object.assign(new ResourceRecommendationsBatchResponse(), model);
        ResourceRecommendationsBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationsBatchResponse>): ResourceRecommendationsBatchResponse {
        if (!model) return null;
        return ResourceRecommendationsBatchResponse.newInstance(<ResourceRecommendationsBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationsBatchResponse) {
        if (!obj) return;

        models.ResourceRecommendationsBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationsBatchResponse): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationsBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_saving_details) {
            models.CostSavingResourceDetails.fixupPrototype(this.cost_saving_details);
        }
        if (this.skipped_by) {
            models.ResourceRecommendationSkippedDetails.fixupPrototype(this.skipped_by);
        }
        if (this.remediation_action_details) {
            for (let val of this.remediation_action_details) {
                models.ResourceRemediationActionDetails.fixupPrototype(val);
            }
        }
        if (this.itsm_action_details) {
            for (let val of this.itsm_action_details) {
                models.ResourceRecommendationITSMEvent.fixupPrototype(val);
            }
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Cost saving details for the resource
     */
    cost_saving_details: models.CostSavingResourceDetails;

    /**
     * Service account id for the resource
     */
    service_account_id: string;

    /**
     * Recommendation ID
     */
    recommendation_id: string;

    /**
     * Impacted Resource Region
     */
    region: string;

    /**
     * Resource type for the impacted resource
     */
    resource: string;

    /**
     * Resource Category for the impacted resource
     */
    resource_category: string;

    /**
     * Resource Group for the impacted resource
     */
    resource_group: string;

    /**
     * Impacted Resource ID
     */
    resource_id: string;

    /**
     * Impacted Resource Name
     */
    resource_name: string;

    /**
     * Resource Type for the impacted resource
     */
    resource_type: string;

    /**
     * Policy ID for which the resource recommendation is generated
     */
    policy_id: string;

    /**
     * Display Name of the policy
     */
    policy_name: string;

    /**
     * Unique ID of the policy execution job (run) that generated this resource recommendation
     */
    policy_job_id: string;

    /**
     * Status of the policy resource recommendation
     */
    status: models.PolicyResourceRecommendationStatus;

    /**
     * Details of the remediation actions triggered for the resource (template action, execution job and status)
     */
    remediation_action_details: Array<models.ResourceRemediationActionDetails>;

    /**
     * ITSM integration events raised as part of the remediation (e.g. incidents created in the integrated ITSM tool)
     */
    itsm_action_details: Array<models.ResourceRecommendationITSMEvent>;

    /**
     * Impact of the policy resource recommendation
     */
    impact: models.PolicyResourceRecommendationImpact;

    skipped_by: models.ResourceRecommendationSkippedDetails;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
